
import { defineComponent, Ref, ref, watchEffect } from "vue";
import { hasTranslation } from "@/i18n";

export default defineComponent({
  name: "Kilometers",
  props: {
    kilometers: {
      type: Number,
    },
  },
  emits: ["changeKilometers"],
  setup(props, { emit }) {
    const currentKilometers: Ref<number | undefined> = ref(props.kilometers || undefined);

    watchEffect(() => {
      emit("changeKilometers", currentKilometers.value);
    });

    return {
      currentKilometers,
      hasTranslation,
    };
  },
});
